export default {
  category: {},
  selectedCategory: {},
};
